// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__QPPAK","image":"Cards_image__hxlL4","dataFromApi":"Cards_dataFromApi__pybKS","locationInIndia":"Cards_locationInIndia__pExgK"};